import { useQuery } from '@tanstack/react-query';
import { doc, getDoc } from 'firebase/firestore';
import firebaseApp from '../../../../firebase-app';
import { FS_PATH_POLLS } from '../../../../constants';
import { Poll } from '../types';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

async function fetchPollById(pollId: string): Promise<Poll | null> {
  const docRef = doc(firebaseApp.db, FS_PATH_POLLS, pollId);
  const docSnap = await getDoc(docRef);

  if (!docSnap.exists()) {
    return null;
  }

  return docSnap.data() as Poll;
}

export function usePollById(pollId: string | null) {
  return useQuery({
    queryKey: ['poll', 'firestore', pollId],
    queryFn: () => fetchPollById(pollId!),
    enabled: !!pollId,
    staleTime: FIVE_MINUTES_MS,
    gcTime: FIVE_MINUTES_MS,
  });
}
